import { NgModule } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  // AuthHttp uses the intercepted Http service, so all requests get the x-vmw-esp-client header
  // Keep default AuthConfig behavior to automatically add Authorization header
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
    tokenGetter: () => localStorage.getItem('token'),
    noJwtError: true
  }), http, options);
}

@NgModule({
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    }
  ]
})
export class AuthModule {}


// WEBPACK FOOTER //
// ./src/app/auth.module.ts